import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { shouldForwardProp } from "theme/utils";

interface IconProps {
  $disabled: boolean;
}

export const StyledIcon = styled(FontAwesomeIcon, {
  shouldForwardProp,
})<IconProps>`
  user-select: none;
  cursor: inherit;

  ${(props) =>
    props.$disabled &&
    css`
      opacity: 0.25;
    `}
`;
